<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { QuillEditor } from '@vueup/vue-quill';
import { ref, onMounted } from "vue";
import { useForm, Link } from '@inertiajs/vue3';
import Loading from 'vue-loading-overlay';
import Multiselect from '@vueform/multiselect';
import FlatPickr from 'vue-flatpickr-component';

const props = defineProps({
    year: String,
    allHotels: Object,
    countries: Object,
    agents: Object,
    flash: Object,
    hotelData: Object,
    user: Object,
});
let isLoading = ref(false);
let roomtypes = ref([]);
let transfers = ref([]);
const options = props.allHotels;
const configDept = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});
const configArrv = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});
const configDob = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});

const paymentDeadline = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});

function handleRoomChange() {
    const roomstemparr = BookingAddform.roomsarray;
    BookingAddform.roomsarray = [];
    for (let i = 0; i < BookingAddform.no_rooms; i++) {
        BookingAddform.roomsarray.push({
            adults: [],
            children: [],
        });
    }
    //preventing the data loss when the user changes the number of rooms
    for (let i = 0; i < roomstemparr.length; i++) {
        if (i < BookingAddform.roomsarray.length) {
            BookingAddform.roomsarray[i] = roomstemparr[i];
        }
    }
}

onMounted(() => {
    const readonlyInput = document.querySelectorAll('input[readonly]');
    readonlyInput.forEach((item) => {
        item.style.backgroundColor = '#eceef14a';
    });
});

function handleAdultsChange(room, $event) {
    const no_adults = parseInt($event.target.value);
    const adulttemparr = room.adults;
    room.adults = [];
    for (let i = 0; i < no_adults; i++) {
        room.adults.push({
            adult_title: '',
            adult_firstname: '',
            adult_lastname: '',
        });
    }
    //preventing the data loss when the user changes the number of rooms
    for (let i = 0; i < adulttemparr.length; i++) {
        if (i < room.adults.length) {
            room.adults[i] = adulttemparr[i];
        }
    }
}

function handleChildrenChange(room, $event) {
    const no_children = parseInt($event.target.value);
    const childrentemparr = room.children;
    room.children = [];
    for (let i = 0; i < no_children; i++) {
        room.children.push({
            child_title: '',
            child_firstname: '',
            child_lastname: '',
            child_dob: '',
        });
    }

    for (let i = 0; i < childrentemparr.length; i++) {
        if (i < room.children.length) {
            room.children[i] = childrentemparr[i];
        }
    }
}

function handleDeptDateChange() {
    configDept.value = {
        ...configDept.value,
        minDate: BookingAddform.arrival_date
    };
}

const handleHotelChange = (e) => {
    const hotel_id = e;
    const hotel = props.hotelData.find((item) => item.id == hotel_id);
    roomtypes.value = hotel.rooms;
    transfers.value = hotel.hotel_transfers;
    isLoading.value = true;
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
};

const BookingAddform = useForm({
    stay_type: '0',
    meal_type: '',
    hotel_id: '',
    room_type1: '',
    nights_room1: '',
    room_type2: '',
    nights_room2: '',
    arrv_hotel_transfer_id: '',
    dept_hotel_transfer_id: '',
    no_rooms: 0,
    agent_id: '',
    arrival_date: '',
    departure_date: '',
    offer_code: '',
    nationalities: '',
    arrival_flight: '',
    departure_flight: '',
    remarks: '',
    roomsarray: [],
    booking_payment_deadline: '',
});

const BookingAddformSubmit = () => {
    BookingAddform.post('/bookings/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/css/vue-quill.snow.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "@vueform/multiselect/themes/default.css";
@import 'flatpickr/dist/themes/material_orange.css';
</style>
<template>
    <AppLayout title="Add New Booking" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="card mb-4">
                <h5 class="card-header">Create Booking</h5>
                <form class="card-body" @submit.prevent="BookingAddformSubmit">
                    <h6 class="text-primary">Property Information</h6>
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label for="stay_type" class="form-label"><b>Stay Type</b></label>
                            <select class="form-select" name="stay_type" v-model="BookingAddform.stay_type">
                                <option value="0">Single Stay</option>
                                <option value="1">Split Stay</option>
                            </select>
                        </div>
                        <div class=" col-md-4">
                            <label for="hotel_id" class="form-label"><b>Hotel Name</b></label>
                            <Multiselect v-model="BookingAddform.hotel_id" :options="options" :closeOnSelect="true"
                                :searchable=true :clearOnSelect=false placeholder="Select hotel ..." track-by="name"
                                label="name" @change="handleHotelChange" :required=true />

                        </div>
                        <div class="col-md-4">
                            <label for="meal_type" class="form-label"><b>Meal Type</b></label>
                            <input type="text" class="form-control" name="meal_type" placeholder="Meal Type"
                                v-model="BookingAddform.meal_type"
                                :class="{ 'is-invalid': BookingAddform.errors.meal_type }">
                            <div v-if="BookingAddform.errors.meal_type" class="invalid-feedback">
                                <div v-text="BookingAddform.errors.meal_type">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="room_type1" class="form-label"><b>Room Type</b></label>
                            <select class="form-select" name="room_type1" required="required"
                                v-model="BookingAddform.room_type1">
                                <option value="" disabled="disabled" selected="selected">Select a room type ...
                                </option>
                                <option v-for="rooms in roomtypes" :key="rooms.room_category.id"
                                    :value="rooms.room_category.id">
                                    {{ rooms.room_category.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="nights_room1" class="form-label"><b>Nights in this room type</b></label>
                            <select class="form-select" name="nights_room1" v-model="BookingAddform.nights_room1"
                                required="required">
                                <option value="" disabled="disabled" selected="selected">Select no of nights ...
                                </option>
                                <option value="1">1 Night</option>
                                <option value="2">2 Nights</option>
                                <option value="3">3 Nights</option>
                                <option value="4">4 Nights</option>
                                <option value="5">5 Nights</option>
                                <option value="6">6 Nights</option>
                                <option value="7">7 Nights</option>
                                <option value="8">8 Nights</option>
                                <option value="9">9 Nights</option>
                                <option value="10">10 Nights</option>
                                <option value="11">11 Nights</option>
                                <option value="12">12 Nights</option>
                                <option value="13">13 Nights</option>
                                <option value="14">14 Nights</option>
                                <option value="15">15 Nights</option>
                                <option value="16">16 Nights</option>
                                <option value="17">17 Nights</option>
                                <option value="18">18 Nights</option>
                                <option value="19">19 Nights</option>
                                <option value="20">20 Nights</option>
                            </select>
                        </div>

                        <div class="col-md-6" v-if="BookingAddform.stay_type == '1'">
                            <select class="form-select" name="room_type2" v-model="BookingAddform.room_type2">
                                <option value="" disabled="disabled" selected="selected">Select a room type ...
                                </option>
                                <option v-for="rooms in roomtypes" :key="rooms.room_category.id"
                                    :value="rooms.room_category.id">
                                    {{ rooms.room_category.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-6" v-if="BookingAddform.stay_type == '1'">
                            <select class="form-select" name="nights_room2" v-model="BookingAddform.nights_room2">
                                <option value="" disabled="disabled" selected="selected">Select number of nights ...
                                </option>
                                <option value="1">1 Night</option>
                                <option value="2">2 Nights</option>
                                <option value="3">3 Nights</option>
                                <option value="4">4 Nights</option>
                                <option value="5">5 Nights</option>
                                <option value="6">6 Nights</option>
                                <option value="7">7 Nights</option>
                                <option value="8">8 Nights</option>
                                <option value="9">9 Nights</option>
                                <option value="10">10 Nights</option>
                                <option value="11">11 Nights</option>
                                <option value="12">12 Nights</option>
                                <option value="13">13 Nights</option>
                                <option value="14">14 Nights</option>
                                <option value="15">15 Nights</option>
                                <option value="16">16 Nights</option>
                                <option value="17">17 Nights</option>
                                <option value="18">18 Nights</option>
                                <option value="19">19 Nights</option>
                                <option value="20">20 Nights</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="arrv_hotel_transfer_id" class="form-label"><b>Arrival Transfer</b></label>
                            <select class="form-select" name="arrv_hotel_transfer_id"
                                v-model="BookingAddform.arrv_hotel_transfer_id" required="required">
                                <option value="" disabled="disabled" selected="selected">Select arrv transfer ...
                                </option>
                                <option v-for="transfer in transfers" :key="transfer.id" :value="transfer.id">
                                    {{ transfer.vessel }}</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="dept_hotel_transfer_id" class="form-label"><b>Departure Transfer</b></label>
                            <select class="form-select" name="dept_hotel_transfer_id"
                                v-model="BookingAddform.dept_hotel_transfer_id" required="required">
                                <option value="" disabled="disabled" selected="selected">Select dept transfer ...
                                </option>
                                <option v-for="transfer in transfers" :key="transfer.id" :value="transfer.id">
                                    {{ transfer.vessel }}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="no_rooms" class="form-label"><b>Number of rooms</b></label>
                            <select class="form-select" name="no_rooms" v-model="BookingAddform.no_rooms"
                                required="required" @change="handleRoomChange">
                                <option value="" disabled="disabled" selected="selected">Select no of rooms ...
                                </option>
                                <option :value="1">1</option>
                                <option :value="2">2</option>
                                <option :value="3">3</option>
                                <option :value="4">4</option>
                                <option :value="5">5</option>
                                <option :value="6">6</option>
                                <option :value="7">7</option>
                                <option :value="8">8</option>
                                <option :value="9">9</option>
                                <option :value="10">10</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="agent_id" class="form-label"><b>Agent</b></label>
                            <select class="form-select" name="agent_id" v-model="BookingAddform.agent_id"
                                required="required">
                                <option value="" disabled="disabled" selected="selected">Type an agent name...</option>
                                <option v-for="agent in agents" :key="agent.id" :value="agent.id">
                                    {{ agent.agency_name }}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="booking_payment_deadline" class="form-label"><b>Booking Payment
                                    Deadline</b></label>
                            <FlatPickr v-model="BookingAddform.booking_payment_deadline" :config="paymentDeadline"
                                class="form-control" placeholder="Payment Deadline" name="booking_payment_deadline"
                                @change="handleDeptDateChange"
                                :class="{ 'is-invalid': BookingAddform.errors.booking_payment_deadline }" />
                            <div v-if="BookingAddform.errors.booking_payment_deadline" class="invalid-feedback">
                                <div v-text="BookingAddform.errors.booking_payment_deadline">
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="my-4 mx-n4">
                    <h6 class="text-primary">Stay Information</h6>
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="arrival_date" class="form-label"><b>Check in</b></label>
                            <FlatPickr v-model="BookingAddform.arrival_date" :config="configArrv" class="form-control"
                                placeholder="Check in Date" name="arrival_date" @change="handleDeptDateChange"
                                :class="{ 'is-invalid': BookingAddform.errors.arrival_date }" />
                            <div v-if="BookingAddform.errors.arrival_date" class="invalid-feedback">
                                <div v-text="BookingAddform.errors.arrival_date">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="departure_date" class="form-label"><b>Check out</b></label>
                            <FlatPickr v-model="BookingAddform.departure_date" :config="configDept" class="form-control"
                                placeholder="Check out Date" name="departure_date"
                                :class="{ 'is-invalid': BookingAddform.errors.departure_date }" />
                            <div v-if="BookingAddform.errors.departure_date" class="invalid-feedback">
                                <div v-text="BookingAddform.errors.departure_date">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="offer_code" class="form-label"><b>Offer Code</b></label>
                            <input type="text" class="form-control" name="offer_code" v-model="BookingAddform.offer_code"
                                placeholder="Offer Code">
                        </div>
                        <div class="col-md-3">
                            <label for="nationalities" class="form-label"><b>Nationalities</b></label>
                            <select class="form-select" name="nationalities" v-model="BookingAddform.nationalities"
                                required="required">
                                <option value="" disabled="disabled" selected="selected">Select a country ...</option>
                                <option v-for="country in countries" :key="country.id" :value="country.id">
                                    {{ country.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="arrival_flight" class="form-label"><b>Arrival Flight / Info</b></label>
                            <input type="text" class="form-control" placeholder="Arrival Flight or Info"
                                name="arrival_flight" v-model="BookingAddform.arrival_flight" />
                        </div>
                        <div class="col-md-6">
                            <label for="departure_flight" class="form-label"><b>Departure Flight / Info</b></label>
                            <input type="text" class="form-control" placeholder="Departure Flight or Info"
                                name="departure_flight" v-model="BookingAddform.departure_flight" />
                        </div>
                    </div>

                    <hr class="my-4 mx-n4" v-if="BookingAddform.no_rooms">
                    <h6 class="text-primary" v-if="BookingAddform.no_rooms">Client Information</h6>
                    <span v-for="(room, index) in BookingAddform.roomsarray" :key="index">
                        <div class="row g-3 mb-4">
                            <h4 class="text-warning">Room: {{ index + 1 }}</h4>
                            <div class="col-md-1">
                                <label for="no_adults" class="form-label"><b>No of Adults</b>
                                </label>
                                <select class="form-select" name="no_adults" @change="handleAdultsChange(room, $event)">
                                    <option :value="0">0</option>
                                    <option :value="1">1</option>
                                    <option :value="2">2</option>
                                    <option :value="3">3</option>
                                    <option :value="4">4</option>
                                    <option :value="5">5</option>
                                    <option :value="6">6</option>
                                    <option :value="7">7</option>
                                    <option :value="8">8</option>
                                    <option :value="9">9</option>
                                    <option :value="10">10</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <label for="no_children" class="form-label"><b>No of Children </b></label>
                                <select class="form-select" name="no_children" @change="handleChildrenChange(room, $event)">
                                    <option :value="0">0</option>
                                    <option :value="1">1</option>
                                    <option :value="2">2</option>
                                    <option :value="3">3</option>
                                    <option :value="4">4</option>
                                    <option :value="5">5</option>
                                    <option :value="6">6</option>
                                    <option :value="7">7</option>
                                    <option :value="8">8</option>
                                    <option :value="9">9</option>
                                    <option :value="10">10</option>
                                </select>
                            </div>

                            <div class="row g-3" v-for="(clientadult, indexi) in room.adults" :key="indexi">
                                <div class="col-md-1">
                                    <label for="adult_rate" class="form-label"><b>Title</b></label>
                                    <select class="form-select" name="adult_title" v-model="clientadult.adult_title">
                                        <option value="" disabled="disabled" selected="selected"></option>
                                        <option value="Mr">Mr</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Ms">Ms</option>
                                        <option value="Dr">Dr</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="adult_firstname" class="form-label"><b>First Name</b></label>
                                    <input type="text" name="adult_firstname" class="form-control" placeholder="First Name"
                                        v-model="clientadult.adult_firstname">
                                </div>
                                <div class="col-md-4">
                                    <label for="adult_lastname" class="form-label"><b>Last Name</b></label>
                                    <input type="text" name="adult_lastname" class="form-control" placeholder="Last Name"
                                        v-model="clientadult.adult_lastname">
                                </div>
                            </div>

                            <div class="row g-3" v-for="(clientchild, indexa) in room.children" :key="indexa">
                                <div class="col-md-1">
                                    <label for="adult_rate" class="form-label"><b>Title</b></label>
                                    <select class="form-select" name="child_title" v-model="clientchild.child_title">
                                        <option value="" disabled="disabled" selected="selected"></option>
                                        <option value="Mr">Mr</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Ms">Ms</option>
                                        <option value="Dr">Dr</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="child_firstname" class="form-label"><b>First Name</b></label>
                                    <input type="text" name="child_firstname" class="form-control" placeholder="First Name"
                                        v-model="clientchild.child_firstname">
                                </div>
                                <div class="col-md-4">
                                    <label for="child_lastname" class="form-label"><b>Last Name</b></label>
                                    <input type="text" name="child_lastname" class="form-control" placeholder="Last Name"
                                        v-model="clientchild.child_lastname">
                                </div>
                                <div class="col-md-2">
                                    <label for="child_dob" class="form-label"><b>DOB</b></label>
                                    <FlatPickr v-model="clientchild.child_dob" :config="configDob" class="form-control"
                                        placeholder="Date of birth" name="child_dob" required="required" />
                                </div>
                            </div>
                        </div>
                    </span>

                    <hr class="my-4 mx-n4">
                    <h6 class="text-primary">Other Information</h6>
                    <div class="row g-3">
                        <div class="col-md-12">
                            <label for="description" class="form-label"><b>Remarks</b></label>
                            <QuillEditor theme="snow" placeholder="    Type extra remarks"
                                v-model:content="BookingAddform.remarks" contentType="html" toolbar="essential"
                                object="true" :searchable="true" name="remarks" />
                        </div>
                    </div>
                    <div class="modal-footer border-0 mt-3">
                        <Link type="button" class="btn btn-label-secondary" :href="'/hotels'">
                        Cancel
                        </Link>
                        <button type="submit" class="btn btn-primary me-sm-3 me-1"
                            :disabled="BookingAddform.processing">Create Booking</button>
                    </div>
                </form>
            </div>
        </div>
    </AppLayout>
</template>